<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard flat>
        <VFlex>
          <ContractsTable />
        </VFlex>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import ContractsTable from '@/components/routes/agentContracts/ContractsTable'
export default {
  name: 'AgencyContracts',
  components: { ContractsTable }
}
</script>
